// a little function to help us with reordering the result

import { detect } from 'detect-browser';

export const getBrowserInfo = () => {
    const browser = detect();
    if (browser) {
        switch (browser.name) {
            case 'chrome':
                return ' https://chromewebstore.google.com/detail/diolog/himacjioffmcnbnlakihdogmnopjjipd?authuser=1&hl=en&pli=1';
            case 'firefox':
                return 'https://addons.mozilla.org/en-US/firefox/addon/diolog';
            case 'safari':
                return 'https://developer.apple.com/safari/extensions';
            case 'edge':
                return 'https://microsoftedge.microsoft.com/addons/Microsoft-Edge-Extensions-Home';
            default:
                return 'Unknown browser';
        }
    }
    return 'Browser detection failed';
};

export const Reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 6;
export const getItemStyle = (isDragging, draggableStyle) => {
    return {
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,
        textAlign: 'right',

        // change background colour if dragging
        background: isDragging ? 'lightgreen' : 'grey',

        // styles we need to apply on draggables
        ...draggableStyle
    };
};

export const getQuestionListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
    padding: 8,
    width: 350
});

export const getAnswerListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
    padding: 4,
    width: 250
});

export const getActiveStatus = (data, type) => {
    const findItem = data.find((item) => item.type === type);

    if (findItem) {
        if (findItem.type === 'WEB_FORM') {
            let isEnabled = findItem?.data?.authorizedOrigins?.length > 0;
            return isEnabled;
        }
        if (findItem.type === 'EMAIL_INTEGRATION') {
            let isEnabled = findItem?.data?.users?.length > 0;
            return isEnabled;
        }
    }
};
